<template>
    <div
        class="sub-header sub-header--filter"
        :class="{ is_open: isShowFilter, 'sub-header--ru': langust == 'ru', 'sub-header--en': langust == 'en' }"
        :key="$route.fullPath">
        <div
            class="filter text_11"
            v-click-outside="
                () => {
                    isShowFilter = false;
                }
            ">
            <div class="filter__buttons text_13" :class="isHasFilters ? 'has_filters' : ''">
                <div
                    class="filter__button filter__reset like-link"
                    v-if="isHasFilters && !isShowFilter"
                    @click="clearFilter">
                    {{ $t("filter_clear") }}
                </div>
                <div class="filter__button filter__toggler like-link" @click="isShowFilter = !isShowFilter">
                    {{ $t("filter") }}
                </div>
                <transition name="fade">
                    <div
                        class="filter__button filter__close like-link"
                        v-if="isShowFilter"
                        @click="isShowFilter = false">
                        {{ $t("close") }}
                    </div>
                </transition>
            </div>
            <div class="filter__content">
                <div
                    class="filter__buttons filter__buttons--modal text_13"
                    :class="isHasFilters ? 'has_filters' : ''"
                    v-if="!$device.isDesktop">
                    <div class="filter__button filter__toggler like-link" @click="isShowFilter = !isShowFilter">
                        {{ $t("filter") }}
                    </div>
                    <transition name="fade">
                        <div
                            class="filter__button filter__close like-link"
                            v-if="isShowFilter"
                            @click="isShowFilter = false">
                            {{ $t("close") }}
                        </div>
                    </transition>
                </div>
                <div class="filter__groups">
                    <!-- <div class="filter__group" v-if="isHasNew">
                        <div class="filter__values">
                            <div
                                class="filter__item"
                                :class="filter.new ? 'filter__item--active' : ''"
                                @click.prevent="applyFilter('new', 1)"
                            >
                                <span>{{ $t("new_arr") }}</span>
                            </div>
                        </div>
                    </div> -->
                    <div class="filter__group" v-if="filters.collections.length">
                        <div class="filter__label">{{ $t("collection") }}</div>
                        <div class="filter__values">
                            <a
                                :href="getUrl('collections', collection.slug)"
                                class="filter__item"
                                :class="{
                                    'filter__item--active':
                                        filter.collections && filter.collections.includes(collection.slug),
                                }"
                                @click.prevent="applyFilter('collections', collection.slug)"
                                v-for="(collection, index) in filters.collections"
                                :key="index">
                                <span>{{ collection.name }}</span>
                            </a>
                        </div>
                    </div>
                    <div class="filter__group" v-if="filters.categories.length">
                        <div class="filter__label">{{ $t("category") }}</div>
                        <div class="filter__values">
                            <a
                                :href="getUrl('categories', cat.slug)"
                                v-for="cat in filters.categories"
                                class="filter__item"
                                :class="{
                                    'filter__item--active': filter.categories && filter.categories.includes(cat.slug),
                                }"
                                @click.prevent="applyFilter('categories', cat.slug, cat.id)"
                                :key="cat.id">
                                <span>{{ cat.name }}</span>
                            </a>
                        </div>
                    </div>
                    <div class="filter__group" v-if="filters.colors.length">
                        <div class="filter__label">{{ $t("color") }}</div>
                        <div class="filter__section">
                            <div class="filter__values">
                                <template v-for="(group, index) in filters.colors">
                                    <template v-if="group.slug">
                                        <a
                                            :href="getUrl('colors', 'group_' + group.slug)"
                                            class="filter__item"
                                            :class="{
                                                'filter__item--stroke': needStroke(group.name),
                                                'filter__item--active':
                                                    filter.colors && filter.colors.includes('group_' + group.slug),
                                            }"
                                            @click.prevent="applyFilter('colors', 'group_' + group.slug)"
                                            :key="'g_' + index">
                                            <span :style="'color: ' + group.code">
                                                <svg-icon name="crystal" width="12" height="12"></svg-icon>
                                            </span>
                                            <span>{{ group.name }}</span>
                                        </a>
                                    </template>
                                    <template v-else>
                                        <a
                                            :href="getUrl('colors', color.slug)"
                                            v-for="(color, sindex) in group.colors"
                                            class="filter__item"
                                            :class="{
                                                'filter__item--stroke': needStroke(color.name),
                                                'filter__item--active':
                                                    filter.colors && filter.colors.includes(color.slug),
                                            }"
                                            @click.prevent="applyFilter('colors', color.slug)"
                                            :key="sindex">
                                            <span :style="'color: ' + color.code">
                                                <svg-icon name="crystal" width="12" height="12"></svg-icon>
                                            </span>
                                            <span>{{ color.name }}</span>
                                        </a>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="filter__group" v-if="filters.sizes.length">
                        <div class="filter__label">{{ $t("size") }}</div>
                        <div class="filter__values">
                            <a
                                :href="getUrl('sizes', size.slug)"
                                class="filter__item"
                                :class="{
                                    'filter__item--active': filter.sizes && filter.sizes.includes(size.slug),
                                }"
                                @click.prevent="applyFilter('sizes', size.slug)"
                                v-for="(size, index) in filters.sizes"
                                :key="index">
                                <span>{{ size.name }}</span>
                            </a>
                        </div>
                    </div>
                    <div class="filter__group" v-if="filters.seasons.length">
                        <div class="filter__label">{{ $t("сезон") }}</div>
                        <div class="filter__values">
                            <a
                                :href="getUrl('seasons', season.slug)"
                                class="filter__item"
                                :class="{
                                    'filter__item--active': filter.seasons && filter.seasons.includes(season.slug),
                                }"
                                @click.prevent="applyFilter('seasons', season.slug)"
                                v-for="(season, index) in filters.seasons"
                                :key="index">
                                <span>{{ season.name }}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="filter__footer flex">
                    <div class="button button--wide" @click="isShowFilter = false">
                        {{ $t("смотреть") }}
                    </div>
                    <div class="button button--wide button--secondary" @click="clearFilter">
                        {{ $t("сбросить фильтр") }}
                    </div>
                </div>
            </div>
            <div class="filter__dimmer" v-if="!$device.isDesktop" @click="isShowFilter = false"></div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "CatalogFilter",
    props: ["data", "isCategoryPage", "isFilterCleared", "apiRoute"],
    data() {
        return {
            isShowFilter: false,
            oldScroll: 0,
            catalogOffsetTop: 0,
            isFilterHided: true,
        };
    },
    watch: {
        $route(val, oldVal) {
            if (Object.keys(val.query).length > 0 && val.fullPath != oldVal.fullPath) {
                this.applyFilter();
            } else {
                this.clearFilter();
            }
        },
        isFilterCleared(val) {
            if (val) {
                this.clearFilter();
                this.$emit("update:isFilterCleared");
            }
        },
        filter() {
            if (document.location.pathname !== this.getUrl()) {
                history.pushState({}, "", this.$utm.url(this.getUrl()));
            }
        },
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
        catalogRoot() {
            if (this.$route.name === "open-sale") {
                return "/sale/";
            }
            if (this.$route.name === "secret-sale") {
                return "/secret-sale/";
            }
            if (this.$route.name === "drop-piercing") {
                return "/drop-piercing/";
            }

            return this.$route.path.includes("/woman/") || this.$route.path.includes("/catalog/") ? "/woman/" : "/man/";
        },

        sorderdFilters() {
            return null;
        },
        filter() {
            return this.data.filter;
        },
        filters() {
            return this.data.filters;
        },
        isHasFilters() {
            if (this.filter) {
                if (this.isCategoryPage) {
                    if (Object.keys(this.filter).length == 1) {
                        if (this.filter.category) {
                            return false;
                        }
                    }
                }
                return Object.keys(this.filter).length > 0;
            }
            return false;
        },
        // isHasNew() {
        //     if (this.isShowCollections && this.collections) {
        //         return (
        //             this.collections.reduce((previous, current) => {
        //                 return previous + (current.new ? 1 : 0);
        //             }, 0) > 0
        //         );
        //     } else {
        //         if (this.data.new) {
        //             return true;
        //         }
        //     }
        //     return false;
        // },
    },
    methods: {
        needStroke(color) {
            return color.toLowerCase() == "белый" || color.toLowerCase() == "white";
        },
        async applyFilter(type, value) {
            const newFilter = this.newFilterValue(type, value);
            newFilter.page = 1;
            const items = await this.$axios.$get(`/api/${this.apiRoute}`, {
                params: newFilter,
            });
            this.$emit("update:filter", {
                items: items.skus,
                filter: newFilter,
                filters: items.filter_values,
            });
        },
        getUrl(newType = false, newValue = false) {
            let newUrl = this.catalogRoot;
            let tempFilter = Object.assign({}, this.filter);
            if (newType) {
                tempFilter = Object.assign({}, this.newFilterValue(newType, newValue));
            }
            // strict filters order
            if (tempFilter.collections) {
                newUrl += `collections=${tempFilter.collections.join(",")}/`;
            }
            if (tempFilter.categories) {
                newUrl += `categories=${tempFilter.categories.join(",")}/`;
            }
            if (tempFilter.colors) {
                newUrl += `colors=${tempFilter.colors.join(",")}/`;
            }
            if (tempFilter.sizes) {
                newUrl += `sizes=${tempFilter.sizes.join(",")}/`;
            }
            if (tempFilter.seasons) {
                newUrl += `seasons=${tempFilter.seasons.join(",")}/`;
            }
            // add other propably filters
            for (const key in tempFilter) {
                if (
                    !["collections", "categories", "colors", "sizes", "seasons", "page", "gender", "catalog"].includes(
                        key
                    )
                ) {
                    const element = tempFilter[key];
                    newUrl += `${key}=${Array.isArray(element) ? element.join(",") : element}/`;
                }
            }

            /**
             *  для страницы giftideas добавляем в урл /giftideas
             *  чтобы не заменялся адрес страницы
             */
            if (
                ["woman-gift-ideas", "man-gift-ideas"].includes(this.$route.name) ||
                this.$route.fullPath.includes("giftideas=1")
            ) {
                newUrl += "giftideas/";
            }

            const queryParams = this.$route.query;
            const queryParamsKeys = Object.keys(queryParams);

            if (queryParamsKeys.length !== 0) {
                newUrl += "?";

                queryParamsKeys.forEach((keyName, index) => {
                    newUrl += `${keyName}=${queryParams[keyName]}`;
                    if (index + 1 < queryParamsKeys.length) newUrl += "&";
                });
            }

            return newUrl;
        },

        newFilterValue(type, value) {
            const tempFilter = Object.assign({}, this.filter);
            if (type) {
                if (["collections", "categories", "colors", "sizes", "seasons"].includes(type)) {
                    if (!tempFilter[type]) tempFilter[type] = [];

                    if (tempFilter[type].includes(value)) {
                        tempFilter[type] = tempFilter[type].filter((el) => el !== value);
                        if (!tempFilter[type].length) {
                            delete tempFilter[type];
                        }
                    } else {
                        tempFilter[type] = [...tempFilter[type], value];
                    }
                } else {
                    tempFilter[type] = value;
                }
            }
            return tempFilter;
        },
        async clearFilter() {
            const collection = await this.$axios.$get(`/api/${this.apiRoute}`);
            const products = { items: collection.skus, filter: {}, filters: collection.filter_values };
            this.$emit("update:filter", products);
            history.pushState({}, "", this.$utm.url(this.catalogRoot));
        },
    },
    mounted() {
        this.catalogOffsetTop = document.querySelector(".catalog")?.offsetTop ?? 0;
    },
};
</script>
<style lang="less" scoped>
.sub-header.sub-header--filter {
    z-index: 4;
    top: 36px;
    .has-promo-header & {
        top: 76px;
    }
}
.filter {
    &__toggler {
        border-bottom: 1px solid;
        .is_open & {
            border-bottom-color: transparent;
        }
    }
    @media @sm {
        width: 100%;
        display: flex;
        justify-content: center;
    }
    &__groups {
        flex-grow: 1;
        overflow-y: auto;
    }
    &__buttons {
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        white-space: nowrap;
        border-color: @border2;
        position: absolute;
        right: 0;
        padding: 9px 32px;
        .trs(all);
        .sub-header--ru & {
            width: 114px;
            &.has_filters {
                width: 220px;
            }
        }
        .sub-header--en & {
            width: 99px;
            &.has_filters {
                width: 168px;
            }
        }
        .sub-header.is_open &.has_filters {
            width: 33.3333vw;
            @media @sm {
                width: 100%;
            }
        }
        &--modal {
            border-bottom: 1px solid @border2;
        }
        .is_open & {
            width: 33.3333vw;
            border-left: 1px @border2 solid;
            @media @sm {
                width: 100%;
                border-left: 0;
            }
        }
        @media @sm {
            padding: 10px 16px;
            position: relative;
            width: 100% !important;
            justify-content: center;
        }
    }
    &__dimmer {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background: rgba(242, 241, 233, 0.7);
        opacity: 0;
        pointer-events: none;
        .trs(opacity);
        .is_open & {
            opacity: 1;
            pointer-events: all;
        }
    }
    &__buttons {
        background: #fff;
        height: 36px;
        border-bottom: 1px solid @border2;
    }
    &__button {
        cursor: pointer;
    }
    &__reset {
        color: @text_3;
        margin-right: 8px;
        flex-grow: 1;
        flex-shrink: 0;
        &:hover {
            color: @accent;
        }
        &::after {
            content: "/";
            padding-left: 8px;
            @media @sm {
                display: none;
            }
        }
        @media @sm {
            margin-left: auto;
            position: absolute;
            right: 16px;
            top: 11px;
        }
    }

    &__close {
        border-bottom: 1px solid;
        margin-left: auto;
        position: absolute;
        right: 32px;
        top: 9px;
        opacity: 0;
        .trs(opacity);
        .is_open & {
            opacity: 1;
        }
        @media @sm {
            right: 16px;
        }
    }

    &__content {
        position: fixed;
        opacity: 0;
        top: 72px;
        z-index: 2;
        right: 0;
        width: 120px;
        bottom: 0;
        pointer-events: none;
        background: @bg;
        border-left: 1px solid @border2;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .trs(all);
        // .is_scrolled & {
        //     height: calc(100vh - 36px);
        //     top: 36px;
        //     @media @sm {
        //         top: 0;
        //         height: 100vh;
        //     }
        // }
        .has-promo-header & {
            top: 112px;
        }
        @media @sm {
            top: 0;
            display: flex;
            flex-direction: column;
            .has-promo-header & {
                top: 0;
            }
            .filter__buttons {
                justify-content: flex-start;
            }
            .filter__reset {
                position: static;
                &:before {
                    display: inline;
                }
            }
        }
        .is_open & {
            opacity: 1;
            width: 33.3333vw;
            pointer-events: all;
            @media @sm {
                width: calc(100% - 80px);
            }
        }
    }
    &__label {
        margin-bottom: 10px;
        color: @text_3;
    }

    &__item {
        min-height: 27px;
        cursor: pointer;
        display: flex;
        align-items: center;
        &:hover {
            color: @purple;
        }
        &:only-child {
            margin-bottom: 0;
        }
        &--active {
            color: @purple_text;
            font-weight: 550;
            span:last-child {
                position: relative;
                &::after {
                    content: "×";
                    position: relative;
                    margin-left: 4px;
                    font-size: 15px;
                    line-height: 13px;
                    top: 2px;
                    margin-right: -13px;
                    display: inline-block;
                }
            }
        }
        &--stroke {
            svg {
                stroke: #000;
                stroke-width: 0.5px;
            }
        }
        @media @notsm {
            &:hover {
                color: @accent;
            }
        }

        svg {
            margin-right: 11px;
            display: block;
            position: relative;
            top: -1px;
        }
    }

    &__values {
        column-count: 2;
        column-gap: 10px;
        div,
        a {
            -webkit-column-break-inside: avoid; /* Chrome, Safari, Opera */
            page-break-inside: avoid; /* Firefox */
            break-inside: avoid; /* IE 10+ */
        }
    }
    &__groups {
        position: relative;
        height: 100%;
        overflow-y: auto;
    }
    &__footer {
        margin-top: auto;
        padding: 16px 28px 32px;
        background: #fff;
        margin-top: -1px;
        border-top: 1px solid @border2;
        .button {
            margin: 0 4px;
        }
        @media @sm {
            padding: 16px 12px;
        }
    }
    &__group {
        width: 100%;
        max-width: 100%;
        padding: 24px 32px;
        border-bottom: 1px @border2 solid;

        @media @sm {
            padding: 24px 16px;
            border-bottom: none;
            width: calc(100vw - 80px);
            & + & {
                border-top: 1px solid @border2;
            }
        }
    }
    &__apply {
        padding: 0 16px 24px;
        margin-top: auto;
    }
}
</style>
